import React, { useState } from 'react'
import { Button, Autocomplete, TextField, Chip } from '@mui/material'
import { Add } from '@mui/icons-material'

import { ChevronDownIcon } from '@/assets/icons/chevron-icons'

function MultipleLangSelector({
  options,
  selectedOption = [],
  values = [],
  handleAdd,
  setSelectedOption,
  setValues,
  multiple = false,
  handleRemoveOption = () => {},
  TextFieldsx = {},
}) {
  const [inputValue, setInputValue] = useState('')

  return (
    <Autocomplete
      filterSelectedOptions
      multiple
      getOptionLabel={option => option.language}
      id="tags-outlined"
      inputValue={inputValue}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      options={options}
      popupIcon={<ChevronDownIcon style={{ color: '#667085' }} width={20} />}
      renderInput={params => (
        <TextField
          {...params}
          InputLabelProps={{
            shrink: false,
          }}
          label=""
          placeholder="Language"
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '8px !important',
            },
            '& .MuiOutlinedInput-root': {
              minHeight: 44,
            },
          }}
        />
      )}
      sx={{
        width: '100%',
        '& .MuiAutocomplete-inputRoot': {
          minHeight: 44,
          padding: '0px 5px',
        },
      }}
      value={selectedOption || values || []}
      onChange={(event, newValue) => {
        setSelectedOption(newValue)
        setInputValue('')
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue)
      }}
    />
  )
}

export default MultipleLangSelector
